@if (blocked()) {
    <div class="blocker"></div>
}
